import { FC } from 'react';

import ProgressBar from 'components/progressBar/ProgressBar';
import './overviewRateRow.scss';
import { Span } from 'components/helpers';
import { IOverviewRateRow } from 'types';
import { mapRateTypeToText } from './helper';

const OverviewRateRow: FC<IOverviewRateRow> = ({ maxTotalCount, type, value }) => {
  const text = mapRateTypeToText[type];

  const percent = 100 * (value / (maxTotalCount || 1));

  return (
    <div className="overview-rate-row">
      <Span text={text} className="title" />
      <div className="progress-bar-container">
        <ProgressBar value={percent} theme="yellow" />
      </div>
      <Span text={value} className="text" />
    </div>
  );
};

export default OverviewRateRow;
